import { useMutation } from '@tanstack/react-query'
import { getJwt } from '@/shared/lib/betterAuth/get-jwt'
import { updateUserPreferences } from '@/services/user.services'
import { USER_QUERY_KEY } from '@/shared/constants/cache'
import { queryClient } from '@/shared/lib/tanstack'
import type { UserPreferences } from '@/shared/types/global.types'

export function useUpdateUserPreferences() {
  return useMutation({
    mutationFn: async (preferences: UserPreferences) => {
      const token = await getJwt()
      if (!token) throw new Error('No JWT token')
      return updateUserPreferences(token, preferences)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USER_QUERY_KEY })
    },
    onError: console.error,
  })
}
